export const genders = new Map([
  ['M', 'Man'],
  ['F', 'Vrouw'],
  ['X', 'Niet-binair'],
]); 